module.exports = __webpack_public_path__ + "static/media/icon-pingtai.e58d02ca.svg";